import ss from '@/utils/session-storage';

const diagnosis = {
  namespaced: true,
  state: {
    diagnosis: {
      diagnosisSpeedSensor: ss.getItem('diagnosisSpeedSensor'),
      diagnosisCadenceSensor: ss.getItem('diagnosisCadenceSensor'),
      diagnosisTorqueSensor: ss.getItem('diagnosisTorqueSensor'),
      diagnosisDriver: ss.getItem('diagnosisDriver'),
      diagnosisMotor: ss.getItem('diagnosisMotor'),
      diagnosisBattery: ss.getItem('diagnosisBattery'),
      diagnosisHmiButton: ss.getItem('diagnosisHmiButton'),
      diagnosisHmiPanel: ss.getItem('diagnosisHmiPanel')
    },
    bikeErrorList: ss.getItem('bikeErrorList'),
    isDisp: ss.getItem('isDisp'),
    isLcm: ss.getItem('isLcm'),
    modelOpenState: ss.getItem('modelOpenState')
  },
  mutations: {
    changeDiagnosisSensor (state, status) {
      if (status.id === 'diagnosisSpeedSensor') {
        if (status.result) {
          ss.setItem('diagnosisSpeedSensor', { status: status, successCount: 1, failedCount: 0 });
          state.diagnosis.diagnosisSpeedSensor = ss.getItem('diagnosisSpeedSensor');
        } else {
          ss.setItem('diagnosisSpeedSensor', { status: status, successCount: 0, failedCount: 1 });
          state.diagnosis.diagnosisSpeedSensor = ss.getItem('diagnosisSpeedSensor');
        }
      } else if (status.id === 'diagnosisCadenceSensor') {
        if (status.result) {
          ss.setItem('diagnosisCadenceSensor', { status: status, successCount: 1, failedCount: 0 });
          state.diagnosis.diagnosisCadenceSensor = ss.getItem('diagnosisCadenceSensor');
        } else {
          ss.setItem('diagnosisCadenceSensor', { status: status, successCount: 0, failedCount: 1 });
          state.diagnosis.diagnosisCadenceSensor = ss.getItem('diagnosisCadenceSensor');
        }
      } else if (status.id === 'diagnosisTorqueSensor') {
        if (status.result) {
          ss.setItem('diagnosisTorqueSensor', { status: status, successCount: 1, failedCount: 0 });
          state.diagnosis.diagnosisTorqueSensor = ss.getItem('diagnosisTorqueSensor');
        } else {
          ss.setItem('diagnosisTorqueSensor', { status: status, successCount: 0, failedCount: 1 });
          state.diagnosis.diagnosisTorqueSensor = ss.getItem('diagnosisTorqueSensor');
        }
      }
    },
    changeDiagnosisMotorBattery (state, status) {
      if (status.title === 'diagnosisMotor') {
        if (status.result) {
          ss.setItem('diagnosisMotor', { status: status, successCount: 1, failedCount: 0 });
          state.diagnosis.diagnosisMotor = ss.getItem('diagnosisMotor');
        } else {
          ss.setItem('diagnosisMotor', { status: status, successCount: 0, failedCount: 1 });
          state.diagnosis.diagnosisMotor = ss.getItem('diagnosisMotor');
        }
      } else if (status.title === 'diagnosisDriver') {
        if (status.result) {
          ss.setItem('diagnosisDriver', { status: status, successCount: 1, failedCount: 0 });
          state.diagnosis.diagnosisDriver = ss.getItem('diagnosisDriver');
        } else {
          ss.setItem('diagnosisDriver', { status: status, successCount: 0, failedCount: 1 });
          state.diagnosis.diagnosisDriver = ss.getItem('diagnosisDriver');
        }
      } else if (status.title === 'diagnosisBattery') {
        if (status.result) {
          ss.setItem('diagnosisBattery', { status: status, successCount: 1, failedCount: 0 });
          state.diagnosis.diagnosisBattery = ss.getItem('diagnosisBattery');
        } else {
          ss.setItem('diagnosisBattery', { status: status, successCount: 0, failedCount: 1 });
          state.diagnosis.diagnosisBattery = ss.getItem('diagnosisBattery');
        }
      }
    },
    changeDiagnosisHmi (state, status) {
      if (status.title === 'Panel') {
        if (status.result.panel === 'passed') {
          ss.setItem('diagnosisHmiPanel', {
            status: status,
            successCount: 1,
            failedCount: 0,
            panel: status.result.panel
          });
          state.diagnosis.diagnosisHmiPanel = ss.getItem('diagnosisHmiPanel');
        } else {
          ss.setItem('diagnosisHmiPanel', {
            status: status,
            failedCount: 1,
            successCount: 0,
            panel: status.result.panel
          });
          state.diagnosis.diagnosisHmiPanel = ss.getItem('diagnosisHmiPanel');
        }
      } else if (status.title === 'Button') {
        const arr = Object.values(status.result);
        const result = arr.includes('failed'); // passed => false

        if (!result) {
          ss.setItem('diagnosisHmiButton', {
            status: status,
            successCount: 1,
            failedCount: 0,
            up: status.result.up,
            down: status.result.down,
            power: status.result.power
          });
          state.diagnosis.diagnosisHmiButton = ss.getItem('diagnosisHmiButton');
        } else {
          ss.setItem('diagnosisHmiButton', {
            status: status,
            failedCount: 1,
            successCount: 0,
            up: status.result.up,
            down: status.result.down,
            power: status.result.power
          });
          state.diagnosis.diagnosisHmiButton = ss.getItem('diagnosisHmiButton');
        }
      }
    },
    addBikeErrorList (state, data) {
      ss.setItem('bikeErrorList', data);
      state.bikeErrorList = ss.getItem('bikeErrorList');
    },
    addIsLcm (state, data) {
      ss.setItem('isLcm', data);
      state.isLcm = ss.getItem('isLcm');
    },
    addIsDisp (state, data) {
      ss.setItem('isDisp', data);
      state.isDisp = ss.getItem('isDisp');
    },
    setModelOpenState (state, data) {
      ss.setItem('modelOpenState', data);
      state.modelOpenState = ss.getItem('modelOpenState');
    }
  },
  actions: {
    changeDiagnosisSensor ({ commit }, status) {
      commit('changeDiagnosisSensor', status);
    },
    changeDiagnosisMotorBattery ({ commit }, status) {
      commit('changeDiagnosisMotorBattery', status);
    },
    changeDiagnosisHmi ({ commit }, status) {
      commit('changeDiagnosisHmi', status);
    },
    addBikeErrorList ({ commit }, key) {
      commit('addBikeErrorList', key);
    },
    addIsLcm ({ commit }, key) {
      commit('addIsLcm', key);
    },
    addIsDisp ({ commit }, key) {
      commit('addIsDisp', key);
    },
    setModelOpenState ({ commit }, key) {
      commit('setModelOpenState', key);
    }
  },
  getters: {
    getDiagnosisSpeedSensor: state => state.diagnosis.diagnosisSpeedSensor,
    getDiagnosisCadenceSensor: state => state.diagnosis.diagnosisCadenceSensor,
    getDiagnosisTorqueSensor: state => state.diagnosis.diagnosisTorqueSensor,
    getDiagnosisDriver: state => state.diagnosis.diagnosisDriver,
    getDiagnosisMotor: state => state.diagnosis.diagnosisMotor,
    getDiagnosisBattery: state => state.diagnosis.diagnosisBattery,
    getDiagnosisHmiButton: state => state.diagnosis.diagnosisHmiButton,
    getDiagnosisHmiPanel: state => state.diagnosis.diagnosisHmiPanel,
    getDiagnosisBikeErrorList: state => state.bikeErrorList,
    getLcm: state => state.isLcm,
    getDisp: state => state.isDisp,
    getModelOpenState: state => state.modelOpenState
  }
};

export default diagnosis;
